module.exports = __webpack_public_path__ + "img/minus.85cbf294.svg";